// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VendorUser
 */
export interface VendorUser {
    /**
     * 
     * @type {string}
     * @memberof VendorUser
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof VendorUser
     */
    principal_id: string;
    /**
     * 
     * @type {string}
     * @memberof VendorUser
     */
    status: VendorUserStatusEnum;
}


/**
 * @export
 */
export const VendorUserStatusEnum = {
    Active: 'active',
    Pending: 'pending'
} as const;
export type VendorUserStatusEnum = typeof VendorUserStatusEnum[keyof typeof VendorUserStatusEnum];


/**
 * Check if a given object implements the VendorUser interface.
 */
export function instanceOfVendorUser(value: object): value is VendorUser {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('principal_id' in value) || value['principal_id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function VendorUserFromJSON(json: any): VendorUser {
    return VendorUserFromJSONTyped(json, false);
}

export function VendorUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): VendorUser {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'principal_id': json['principal_id'],
        'status': json['status'],
    };
}

export function VendorUserToJSON(json: any): VendorUser {
    return VendorUserToJSONTyped(json, false);
}

export function VendorUserToJSONTyped(value?: VendorUser | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'principal_id': value['principal_id'],
        'status': value['status'],
    };
}
